
import { cn } from '@/lib/utils'

interface HomeContentContainerProps {
  title?: React.ReactNode
  subtitle?: React.ReactNode
  children?: React.ReactNode
  rightContent?: React.ReactNode
  contentClassName?: string
  titleTag?: React.ReactNode
  titleCenter?: boolean
  leftContent?: React.ReactNode
}

export function HomeContentContainer({
  title,
  subtitle,
  children,
  rightContent,
  contentClassName,
  titleTag,
  titleCenter,
  leftContent,
}: HomeContentContainerProps) {
  return (
    <div className="h-full w-full flex justify-center items-start">
      <div className={cn('flex flex-col justify-center items-start gap-4 w-full', contentClassName)}>
      {leftContent && <div className="flex items-center justify-start">{leftContent}</div>}
        <div className="flex justify-between items-center w-full">
        
        <div className={cn("flex flex-col justify-center items-start", titleCenter && "w-full items-center justify-center")}>
          {title && <span className="font-bold text-[48px]">{title}</span>}
          {subtitle && <p className="text-subtitle">{subtitle}</p>}
        </div>
        {rightContent && <div className="flex items-center justify-end">{rightContent}</div>}
        </div>
        <div className="flex flex-col w-full gap-4 justify-center">{children}</div>
      </div>
    </div>
  )
}
